import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'
import Dropdown from '../misc/Dropdown'
import Breadcrumbs from '../displays/Breadcrumbs'
var ConcurrentViewers = null
try {
  ConcurrentViewers = require('../../../projects/' + process.env.REACT_APP_PROJECT + '/components/core/ConcurrentViewers').default
} catch (e) {}
const icons = {
  'inventory': 'fa-cubes',
  'flow': 'fa-home',
  'access': 'fa-home',
  'address': 'fa-map',
  'event': 'fa-sliders',
  'administration': 'fa-gear',
  'configuration': 'fa-wrench',
  'service': 'fa-suitcase',
  'customer': 'fa-address-book',
  'catalogue': 'fa-book',
  'ticket': 'fa-ticket',
  'monitoring': 'fa-area-chart'
}
class ContentHeader extends Component {
  render () {
    ReactTooltip.rebuild()
    return (
      <div className='content-header clearfix'>
        <ReactTooltip effect='solid' place='top' type='dark' />
        <div className='row'>
          <div className='col-md-6'>
            <div className='breadcrumbs'>
              <h4><i className={'fa ' + (this.props.icon ? this.props.icon : icons[window.location.hash.split('/')[1]])} />{this.props.title}</h4>
              {!this.props.breadcrumbs && !!this.props.subtitle && <small> {this.props.subtitle}</small>}
              {this.props.breadcrumbs && <Breadcrumbs links={this.props.breadcrumbs} />}
            </div>

            { this.props.enableConcurrentViewers && ConcurrentViewers ? <ConcurrentViewers /> : '' }
          </div>
          <div className='col-md-6 pull-right'>
            {this.props.buttons && !!this.props.buttons.length && <div className={'content-header-buttons pull-right ' + (this.props.buttons ? '' : ' hidden')}>
              {this.props.buttons.map((button, index) => {
                if (button.hidden) return null
                if (button.dropdown) {
                  return (
                    <Dropdown tip={button.tip} key={'contentheader_' + index} links={button.links} icon={button.icon} />
                  )
                }
                return (
                  <a href={button.href} target={(button.blank ? '_blank' : '')} key={'contentheader_' + index} onClick={button.event} data-tip={button.tip} className='box-button pull-left'><i className={'fa fa-fw ' + button.icon} /></a>
                )
              })}
            </div>}
          </div>
        </div>
      </div>
    )
  }
}
export default ContentHeader



// WEBPACK FOOTER //
// ./src/components/basic/containers/ContentHeader.js